import { DataHandler } from '../utils/DataHandler';
import type { TopScorerPlayer } from '../utils/types';

import type { StateCreator } from '@shared-types/zustand.types';
import { Warn } from '@utilities/logging';

export type PlayersSlice = {
  playersInfo: TopScorerPlayer[];
  isLoadingPlayers: boolean;
  loadPlayersInfo: () => Promise<void>;
};

export const playerSlice: StateCreator<PlayersSlice> = (set) => ({
  playersInfo: [] as TopScorerPlayer[],
  isLoadingPlayers: true,
  loadPlayersInfo: async () => {
    set({ isLoadingPlayers: true }, false, 'loadPlayersInfo');

    try {
      const apiInstance = DataHandler.getInstance();
      const data = await apiInstance.loadPlayersInfo();
      set({ playersInfo: data, isLoadingPlayers: false }, false, 'loadPlayersInfo');
    } catch (error) {
      Warn('Failed to load players info', error);
      set({ isLoadingPlayers: false }, false, 'loadPlayersInfo');
    }
  },
});
